export default {
  getRemRegionList: state => state.remRegionList,
};



// WEBPACK FOOTER //
// ./src/vuex/rem/region/regionGetters.js